function isExpiredLinkError(error) {
    if ('error' in error) {
        const description = error.error_description || error.errorDescription;
        if (description === null || description === void 0 ? void 0 : description.toLowerCase().includes('the verification code has expired')) {
            return true;
        }
        // For an already activated account we inform the user the same as for an expired link
        if (description === null || description === void 0 ? void 0 : description.toLowerCase().includes('wrong email or verification code')) {
            return true;
        }
    }
    return false;
}

export { isExpiredLinkError };
//# sourceMappingURL=is-expired-link-error.js.map
